import React, { useState } from 'react';

import DonationModal from './DonationModal';
import Pagination from '../../components/Pagination';

export interface DonationsProps {
  name: string;
  description: string;
  targetAmount: number;
  type: string;
  status: string;
  createdAt: string;
}

const donationLists: DonationsProps[] = [
  {
    name: "Free Carbon Africa",
    description: "Free Carbon Africa",
    targetAmount: 2000,
    type: "One Time",
    status: "Active",
    createdAt: "Today"
  },
  {
    name: "Clean Water Initiative",
    description: "Providing clean drinking water to rural areas.",
    targetAmount: 5000,
    type: "Recurring",
    status: "Active",
    createdAt: "Last Week"
  },
  {
    name: "Education for All",
    description: "Supporting underprivileged children with education.",
    targetAmount: 10000,
    type: "One Time",
    status: "Active",
    createdAt: "Last Month"
  },
  {
    name: "Food for the Hungry",
    description: "Distributing food to families in need.",
    targetAmount: 3000,
    type: "Recurring",
    status: "Active",
    createdAt: "Yesterday"
  },
  {
    name: "Disaster Relief Fund",
    description: "Helping victims of natural disasters.",
    targetAmount: 15000,
    type: "One Time",
    status: "Inactive",
    createdAt: "Two Months Ago"
  },
  {
    name: "Wildlife Conservation",
    description: "Protecting endangered species and their habitats.",
    targetAmount: 7000,
    type: "Recurring",
    status: "Active",
    createdAt: "Three Weeks Ago"
  },
  {
    name: "Medical Aid Program",
    description: "Providing essential healthcare and medicine.",
    targetAmount: 12000,
    type: "One Time",
    status: "Active",
    createdAt: "Today"
  },
  {
    name: "Renewable Energy Initiative",
    description: "Promoting sustainable energy solutions.",
    targetAmount: 9000,
    type: "Recurring",
    status: "Active",
    createdAt: "Last Month"
  }
];


const Donations = () => {
  const [activeModal, setActiveModal] = useState<boolean>(false);
  const [selectedDonation, setSelectedDonation] = useState<DonationsProps | null>(null);

  const openEditModal = (donation: DonationsProps) => {
    setSelectedDonation(donation);
  };

  const closeEditModal = () => {
    setSelectedDonation(null);
  };

  return (
    <div className=" w-screen min-h-screen py-16 px-16">
      <div className="mb-4 text-sm text-gray-500">
        Dashboard &gt; <span className="text-blue-600">Donations</span>
      </div>
      <h1 className="text-3xl font-bold mb-4">Donations</h1>
      <div className="flex justify-end mb-4">
          <button className="bg-green-700 text-white px-4 py-2 rounded-lg hover:bg-green-800 cursor-pointer" onClick={() => setActiveModal(true)}>
            Create Donation
          </button>
      </div>
        <table className="min-w-full bg-white border border-gray-200 rounded-lg">
          <thead>
              <tr className="bg-gray-50 text-left">
              <th className="px-4 py-3 border-b text-gray-600">Donation Name</th>
              <th className="px-4 py-3 border-b text-gray-600">Type</th>
              <th className="px-4 py-3 border-b text-gray-600">Target Amount</th>
              <th className="px-4 py-3 border-b text-gray-600">Status</th>
              <th className="px-4 py-3 border-b text-gray-600">Created At</th>
              <th className="px-4 py-3 border-b text-gray-600">Actions</th>
              </tr>
          </thead>
          <tbody>
            {donationLists.map((donation, index) => (
              <tr key={index} className="border-b hover:bg-gray-50">
                  <td className="px-4 py-3 text-gray-700">{donation.name}</td>
                  <td className="px-4 py-3 text-gray-700">{donation.type}</td>
                  <td className="px-4 py-3 text-gray-700">${donation.targetAmount}</td>
                  <td className="px-4 py-3">
                      <span className={`px-2 py-1 rounded text-sm ${donation.status === "Active"? "bg-green-100 text-green-700": "bg-red-100 text-red-700"}`}>
                          {donation.status}
                      </span>
                  </td>
                  <td className="px-4 py-3 text-gray-700">
                      {donation.createdAt}
                  </td>
                  <td className="px-4 py-3 text-gray-700 relative">
                    <button className="px-3 py-1 border rounded text-gray-600 mr-4 hover:bg-green-600 hover:text-white">
                      View
                    </button>
                    <button onClick={() => openEditModal(donation)} className="px-3 py-1 border rounded text-gray-600 hover:bg-green-600 hover:text-white">
                      Edit
                    </button>
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="mt-4">
                {donationLists.length > 0 && (
                    <Pagination
                        currentPage={1}
                        totalPages={10}
                        onPageChange={(page) => console.log('Page:', page)}
                        indexOfFirstEntry={1}
                        indexOfLastEntry={10}
                        totalEntries={100}
                    />
                )}
            </div>
        {activeModal && (
          <DonationModal
            handleClose={() => setActiveModal(false)}
          />
        )}

        {selectedDonation && (
          <DonationModal
            handleClose={closeEditModal}
            selectedDonation={selectedDonation}
          />
        )}

    </div>
  )
}

export default Donations